import React, { useState, useEffect, useMemo, useRef } from "react";
import styles from "./styles.module.scss";
import DayIcon from "assets/icons/dayIcon.svg?react";
import WeekIcon from "assets/icons/WeekIcon.svg?react";
import MonthIcon from "assets/icons/monthIcon.svg?react";
import ListIcon from "assets/icons/listIcon.svg?react";
import TaskIcon from "assets/icons/new-task.svg?react";
import SecondCheckbox from "components/SecondCheckbox";
import { useOnClickOutside } from "hooks/useClickOutside";
import { useTranslation } from "react-i18next";

const ContextMenuCalendar = ({
  handleClickNavigation,
  calendarView,
  onlyFromCourtPortal,
}: {
  handleClickNavigation: (a: string) => void;
  calendarView: string;
  onlyFromCourtPortal?: boolean;
}) => {
  const { t } = useTranslation();

  const availableTabs = useMemo(() => [
    { id: "day", label: t("calendar.day"), icon: DayIcon },
    { id: "week", label: t("calendar.week"), icon: WeekIcon },
    { id: "month", label: t("calendar.month"), icon: MonthIcon },
    { id: "list", label: t("actions.events"), icon: ListIcon },
    { id: "tasks", label: t("menu.taskList"), icon: TaskIcon },
  ], [t]);

  const courtPortalTabs = useMemo(() => [
    { id: "day", label: t("calendar.day"), icon: DayIcon },
    { id: "week", label: t("calendar.week"), icon: WeekIcon },
    { id: "month", label: t("calendar.month"), icon: MonthIcon },
  ], [t]);

  const [, setActiveTabs] = useState<string[]>([]);
  const [temporaryActiveTabs, setTemporaryActiveTabs] = useState<string[]>([]);

  useEffect(() => {
    const storedTabs = localStorage.getItem("calendarTabs");
    if (storedTabs) {
      setActiveTabs(JSON.parse(storedTabs));
      setTemporaryActiveTabs(JSON.parse(storedTabs)); // Initialize temporary state
    } else {
      const defaultTabs = availableTabs.map((tab) => tab.id);
      setActiveTabs(defaultTabs);
      setTemporaryActiveTabs(defaultTabs); // Initialize temporary state
    }
  }, []);

  const handleToggleTab = (id: string) => {
    if (temporaryActiveTabs.includes(id)) {
      setTemporaryActiveTabs(
        temporaryActiveTabs.filter((tabId) => tabId !== id)
      );
    } else {
      setTemporaryActiveTabs([...temporaryActiveTabs, id]);
    }
  };

  const [showDropdown, setShowDropdown] = useState(false);
  const ref = useRef(null);

  useOnClickOutside(ref, () => {
    if (!showDropdown) return;
    setShowDropdown(false);
    setActiveTabs(temporaryActiveTabs); // Save changes when dropdown is closed
    localStorage.setItem("calendarTabs", JSON.stringify(temporaryActiveTabs));
  });

  return (
    <div className={styles.menu}>
      {(!onlyFromCourtPortal
        ? availableTabs.filter((tab) => temporaryActiveTabs.includes(tab.id))
        : courtPortalTabs
      ).map((tab) => (
        <React.Fragment key={tab.id}>
          <div
            onClick={() => handleClickNavigation(tab.id)}
            className={`${styles.box} ${
              calendarView === tab.id && styles.activeText
            }`}
          >
            <tab.icon />
            {tab.label}
            {/* {calendarView === tab.id && <div className={styles.active}></div>} */}
          </div>

          <div className={styles.splitter}></div>
        </React.Fragment>
      ))}

      {!onlyFromCourtPortal && (
        <div ref={ref} className={styles.box}>
          <div
            onClick={() => setShowDropdown(!showDropdown)}
            className={styles.add}
          >
            + {t("menu.tabs")}
          </div>
          {showDropdown && (
            <div className={styles.dropdown}>
              <div className={styles.dropdownWrapper}>
                {availableTabs.map((tab) => (
                  <div key={tab.id} className={styles.dropdownBox}>
                    <SecondCheckbox
                      onChange={() => {
                        handleToggleTab(tab.id);
                      }}
                      value={temporaryActiveTabs.includes(tab.id)}
                    />
                    {tab.label}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ContextMenuCalendar;
